import { render, staticRenderFns } from "./ViewNav.vue?vue&type=template&id=38f637c7&scoped=true&"
import script from "./ViewNav.vue?vue&type=script&lang=js&"
export * from "./ViewNav.vue?vue&type=script&lang=js&"
import style0 from "./ViewNav.vue?vue&type=style&index=0&id=38f637c7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f637c7",
  null
  
)

export default component.exports